/**
 * Dependency imports
 */
import React from 'react';
import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { FirebaseError } from 'firebase/app';

/**
 * Local imports
 */
import { auth } from '@/firebase/auth';

/**
 * Default export
 */
export const usePasswordReset = () => {
  const [info, setInfo] = React.useState<any>(null);
  const [status, setStatus] = React.useState<
    'idle' | 'pending' | 'complete' | 'error'
  >('idle');

  const parseFirebaseError = (err: FirebaseError) =>
    new Error(err.message.replace(/^Firebase:|\((.*?)\).$/g, '').trim(), {
      cause: err.code,
    });

  const resetPassword = async (email: string) =>
    new Promise<void>((resolve, reject) => {
      setStatus('pending');

      sendPasswordResetEmail(auth, email)
        .then((creds) => {
          setStatus('complete');
          setInfo(creds);
          resolve();
        })
        .catch((err) => {
          setStatus('error');
          setInfo(parseFirebaseError(err));
          reject(err);
        });
    });

  return [
    resetPassword,
    {
      info,
      status,
    },
  ] as const;
};
